import UploadCsvModal from '../upload-csv-modal'
import { Upload } from '../../services/api/upload'

const UploadInternalOrderIdsModal = ({ visible, onCancel, onComplete }) => {
	return (
		<UploadCsvModal
			title='Replace Order Numbers'
			type='ORDER_INTERNAL_IDS'
			fields={[
				{ label: 'Existing Order Number', key: 'internalId', type: 'string' },
				{ label: 'Updated Order Number', key: 'newInternalId', type: 'string' }
			]}
			firstStepPrompt='Upload a CSV or Excel file to replace order numbers in bulk.'
			visible={visible}
			onCancel={onCancel}
			onComplete={onComplete}
			uploadTask={Upload.uploadOrderIdsCsv}
			disableSteps={true}
		/>
	)
}

export default UploadInternalOrderIdsModal
